export default __webpack_public_path__ + "static/media/lock-icon.f6281969.svg";